import { DASHBOARD_ROLE } from '../Helper/Constant';

export const MarketPlaceUIFunction = {
    MARKET_PLACE: 'marketPlace',
    MARKET_PLACE_INIT: 'marketPlaceInit',
    VALIDATE_MARKET_PLACE: 'validateMarketPlaceData',
    ADD_MARKET_PLACE: 'saveMarketPlaceData',
    SEARCH_MARKET_PLACE: 'searchMarketPlace',
    GET_PERMISSION_BY_CONNECTED_APPS: 'getPermissionByConnectedApps',
    COMMON_FUNCTION: 'commonFunction',
    SEARCH_APP: 'searchApp',
    ASSIGN_PERMISSION: 'assignPermissionToConnectedApp',
    CONNECTED_APP_PERMISSION: 'connectedAppPermission',
    CONNECTED_APPS_WITHOUT_PERMISSIONS: 'connectedAppsWithoutPermissions',
    CONNECTED_APPS: 'connectedApps',
    EDIT_CONNECTED_APP: 'editConnectedApp',
    UPDATE_RISK_LEVELS: 'updateRiskLevels',
    CHECK_LOGO: 'checkMarketPlaceLogo',
};

export const PermissionRiskLevels = ['Critical', 'High', 'Medium', 'Low'];

export const MarketPlaceDataTypes = {
    connectedApps: {
        name: 'Connected Apps',
        key: 'connected_apps',
    },
    permission: {
        name: 'Permission',
        key: 'permission',
    },
};

export const MarketPlaceAllowRoles = [DASHBOARD_ROLE.ADMIN, DASHBOARD_ROLE.RESEARCH_ADMIN];

export const MarketPlaceStrings = {
    RULE_MSG: 'Please fill this',
    SEARCH_EMPTY: 'Search box can not be empty',
    SAAS_ID_NUMBER: 'Saas App Id Field should contain only numbers',
    DESCRIPTION_SP_CHAR: 'Description contains special character.',
    SUCCESS_CONNECTED_APP: 'Successfully Added Connected App',
    SUCCESS_PERMISSION: 'Successfully Added Permission',
    SELECT_PERMISSION: 'Please select permission',
    MARKET_PLACE_CARD_TITLE: 'Market Places',
    SEARCH_APP_CARD_TITLE: 'Search Connected Apps',
    CONNECTED_APP_CARD_TITLE: 'Add Connected Apps',
    PERMISSION_CARD_TITLE: 'Add Permission',
    PERMISSION_MODAL_TITLE: 'Assign Permission',
    SEARCH_SAAS_MODAL_TITLE: 'Search Saas App',
    ADD_PERMISSION_BUTTON: 'Add New Permission',
    SUCCESS_DELETE_APP_MSG: 'Successfully Deleted Connected App',
    EDIT_APP_MODAL_TITLE: 'Edit Connected App',
    SAVED_SUCCESS_MSG: 'Successfully saved',
    NO_APPS_FOR_RISK_LEVEL: 'No apps to update risk level',
};

export const SpecialCharacterRegex = /[^a-zA-Z0-9_\s()*&_+\-.\:?,'"@!/]/;

const defaultFieldRule = { required: true, message: MarketPlaceStrings.RULE_MSG };

export const FormFieldRules = {
    default: [defaultFieldRule],
    description: [
        defaultFieldRule,
        ({}) => ({
            validator(_, value) {
                if (SpecialCharacterRegex.test(value)) {
                    return Promise.reject(new Error(MarketPlaceStrings.DESCRIPTION_SP_CHAR));
                }
                return Promise.resolve();
            },
        }),
    ],
};

export const ConnectedAppFormType = {
    add: { key: 'add' },
    edit: { key: 'edit' },
};

export const ConnectedAppFields = {
    connected_app_name: 'connected_app_name',
    display_name: 'display_name',
    publisher_name: 'publisher_name',
    category_id: 'category_id',
    publisher_url: 'publisher_url',
    description: 'description',
    saas_appid: 'saas_appid',
    app_logo_url: 'app_logo_url',
    fav_icon_logo_url: 'fav_icon_logo_url',
    mp_appid: 'mp_appid',
};
